<template>
  <div class="cta-container">
    <button
      class="cta-button"
      ref="ctaButton"
      @mousemove="handleMouseMove"
    >
      <!-- Glow layer behind content -->
      <div class="hover-effect-container" :style="gradientPosition">
        <div class="hover-gradient-large"></div>
        <div class="hover-gradient-small"></div>
      </div>

      <span class="btn-label">Hover here</span>

      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 9" class="btn-arrow">
        <path fill="currentColor" fill-rule="evenodd" d="m12.495 0 4.495 4.495-4.495 4.495-.99-.99 2.805-2.805H0v-1.4h14.31L11.505.99z" clip-rule="evenodd"/>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'GlowButtonEffect',
  data() {
    return {
      gradientPosition: {
        transform: 'translateX(0px) translateZ(0px)',
      },
    };
  },
  methods: {
    handleMouseMove(event) {
      const button = this.$refs.ctaButton;
      const rect = button.getBoundingClientRect();
      const x = event.clientX - rect.left;
      // Center the 204px container on the cursor X
      this.gradientPosition.transform = `translateX(${x - 102}px) translateZ(0px)`;
    },
  },
};
</script>

<style lang="scss" scoped>
.cta-container {
  align-items: center;
  display: flex;
  justify-content: center;
  height: 25vh;
  border-radius: 24px;
  margin: 20px 0;
}

.cta-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 0 52px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: -0.015em;
  text-transform: uppercase;
  color: #5a250a;
  background: #fcf0e0;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 999px;
  overflow: hidden;
  cursor: pointer;
  /* outer glow that intensifies when the inner light hits the edge */
  box-shadow:
    0 0 0 1px rgba(255, 200, 140, 0.15),
    0 0 18px rgba(255, 180, 100, 0.18);
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow:
      0 0 0 1px rgba(255, 210, 150, 0.35),
      0 0 28px rgba(255, 180, 100, 0.32);
  }
}

.btn-label,
.btn-arrow {
  position: relative;
  z-index: 10;
  color: #5a250a;
}

.btn-arrow {
  width: 17px;
  height: 9px;
  flex-shrink: 0;
}

/* Moving container — fixed 204px wide, follows cursor X */
.hover-effect-container {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 204px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 0;
  transition: transform 0.08s linear;
}

/* Large warm radial — exact Huly values */
.hover-gradient-large {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 121px;
  height: 121px;
  background: radial-gradient(
    50% 50% at 50% 50%,
    #fffff5 3.5%,
    #ffaa81 26.5%,
    #ffda9f 37.5%,
    rgba(255, 170, 129, 0.50) 49%,
    rgba(210, 106, 58, 0.00) 92.5%
  );
  transform: translate(-50%, -50%);
}

/* Small horizontal radial with blur — exact Huly values */
.hover-gradient-small {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 204px;
  height: 103px;
  background: radial-gradient(
    43.3% 44.23% at 50% 49.51%,
    #fffff7 29%,
    #fffacd 48.5%,
    #f4d2bf 60.71%,
    rgba(214, 211, 210, 0.00) 100%
  );
  transform: translate(-50%, -50%);
  filter: blur(5px);
}
</style>
